import {store} from "@risingstack/react-easy-state";

const AddTriggerState = store({
    isOpen: false,
    triggerName: ''
});

export default AddTriggerState;